module.exports = __webpack_public_path__ + "img/banner05.20570b24.png";